import type { SMSTemplateMaster, SendFreeFormSmsRequest, SendSmsTemplateRequest, SmsTemplateMasterResponse, EmailFromMasterResponse } from '@fitness-force/models';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import type { EmailTemplateMasterById, EmailTemplateMasterResponse, ListWhatsAppSenderConfigurationMasterResponse, ListWhatsAppTemplateMaster, NotificationMasterResponse, PushNotificationTemplateMaster, PushNotificationTemplateMasterResponse, SMSFromMasterResponse, SendEmailTemplateRequest, SendFreeFormEmailRequest, ThreadResponse, WhatsAppTemplateMaster } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, catchError, map, throwError } from 'rxjs';
import { OwnershipLevel } from '@fitness-force/enum';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  
  getNotificastionTemplates(tenantId:number): Observable<NotificationMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_NOTIFICATIONS
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplates(tenantId:number): Observable<EmailTemplateMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_TEMPLATES
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplateById(tenantId:number, templateId:number): Observable<EmailTemplateMasterById> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_TEMPLATE_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{template_id}', templateId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSmsTemplates(tenantId:number): Observable<SmsTemplateMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_TEMPLATES
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplates(tenantId:number): Observable<ListWhatsAppTemplateMaster> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendEmailFromList(tenantId:number): Observable<EmailFromMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_FROM_CONFIG
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendSMSFromList(tenantId:number): Observable<SMSFromMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_SENDER_CONFIG
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSMSTemplateById(tenantId:number, templateId:number): Observable<SMSTemplateMaster> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_TEMPLATE_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{template_id}', templateId.toString());
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendFreeFormSms(tenantId:number,clientId:number, payload:SendFreeFormSmsRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_FREE_FORM_SMS
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString());
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedSms(tenantId:number,clientids:any[],payload:SendSmsTemplateRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_TEMPLATED_SMS
      .replace('{tenant_id}', tenantId.toString());
    const encodedArray = clientids.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendFreeFormEmail(tenantId:number,clientId:number,payload:SendFreeFormEmailRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_FREE_FORM_EMAIL
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString());
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedEmail(tenantId:number, clientids:any[], payload:SendEmailTemplateRequest): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_TEMPLATED_EMAIL
      .replace('{tenant_id}', tenantId.toString());
    const encodedArray = clientids.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendWhatsAppMessage(tenantId:number,clientId:number,payload:any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_FREE_FORM_WHATSAPP
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString());
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    },
   
    ).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if(error.status === 400){
          return throwError(()=> new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  SendTemplatedWhatsAppMessage(tenantId:number,clientIds:any[],payload:any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.SEND_TEMPLATED_WHATSAPP
      .replace('{tenant_id}', tenantId.toString());
    const encodedArray = clientIds.map(item => encodeURIComponent(item)).join(',');
    let params = new HttpParams();
    params = params.set('client_id', encodedArray);
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers,params: params
    }).pipe(
      map((res: any) => {
        if (res) {
          return res
        }
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if(error.status === 400){
          return throwError(()=> new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  // Automation Changes

  getEmailTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<EmailTemplateMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_EMAIL_TEMPLATES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_EMAIL_TEMPLATES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master`;
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getEmailTemplateByIdWithOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<EmailTemplateMasterById> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_EMAIL_TEMPLATE_BY_ID
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_EMAIL_TEMPLATE_BY_ID
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_TEMPLATE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_template_master/${templateId}`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendEmailFromListByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<EmailFromMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_EMAIL_FROM_CONFIGS;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_EMAIL_FROM_CONFIGS
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_EMAIL_FROM_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/email_from_config_master`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSendSMSFromListByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<SMSFromMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_SMS_SENDER_CONFIGS;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_SMS_SENDER_CONFIGS
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_SENDER_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_sender_config_master`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSmsTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<SmsTemplateMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_SMS_TEMPLATES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_SMS_TEMPLATES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getSMSTemplateByIdWithOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<SMSTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_SMS_TEMPLATE_BY_ID
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_SMS_TEMPLATE_BY_ID
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_SMS_TEMPLATE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/sms_template_master/${templateId}`
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_WHATSAPP_TEMPLATES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_WHATSAPP_TEMPLATES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  ListWhatsAppSenderConfigByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppSenderConfigurationMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_WHATSAPP_CONFIGS;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_WHATSAPP_CONFIG
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_CONFIG
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_config_master`
        break;
    }
    return this.http.get<ListWhatsAppSenderConfigurationMasterResponse>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetWhatsAppTemplateMasterByOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<WhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_WHATSAPP_TEMPLATE_BY_ID
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_WHATSAPP_TEMPLATE_BY_ID
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/whatsapp_template_master/${templateId}`
        break;
    }
    return this.http.get<WhatsAppTemplateMaster>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getPushNotificationTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<PushNotificationTemplateMasterResponse> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_PUSH_TEMPLATES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_PUSH_TEMPLATES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_PUSH_NOTIFICATION_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_PUSH_NOTIFICATION_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetPushNotificationTemplateMasterByOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<PushNotificationTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_PUSH_TEMPLATE_BY_ID
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.FRANCHISE_GROUP.GET_PUSH_TEMPLATE_BY_ID
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_PUSH_NOTIFICATION_TEMPLATE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/push_notification_template_master/${templateId}`
        break;
    }
    return this.http.get<PushNotificationTemplateMaster>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientThreads(tenantId: any, allParams: Array<any>): Observable<ThreadResponse> {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){
     allParams.forEach((p: any) => {
       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_CLIENT_THREADS
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get(url,
     {headers: this.httpOptions.headers , params: parsedParams}).pipe(
      map((res: any) => {
          return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  markAsRead(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_EMAIL_AS_READ
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{thread_id}', threadId)
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsSmsRead(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_AS_READ
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsWhatsappRead(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_AS_READ
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })  
      );
  }

  markAsSmsUnread(tenantId:number,clientId:number, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_SMS_AS_UNREAD
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => { 
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })  
      );
  }

  markAsWhatsappUnread(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_AS_UNREAD
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{thread_id}', threadId)
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res;
        }), 
        catchError((error: Response) => {   
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markAsEmailUnread(tenantId:number,clientId:number, threadId:string, interactionId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_EMAIL_AS_UNREAD
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', clientId.toString())
      .replace('{thread_id}', threadId)
      .replace('{interaction_id}', interactionId.toString());
    return this.http.post(url, { headers: this.httpOptions.headers })
      .pipe(
        map((res: any) => {
          return res; 
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));  
        })
      );
  }
  
}